import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Welcome from "@/components/site/Welcome";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import About from "@/components/site/About";
import Events from "@/components/site/Events";
import Facilities from "@/components/site/Facilities";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

export default function Home() {
  return (
    <main className="min-h-screen bg-background text-foreground" data-testid="home-page">
      <Nav />
      <Hero />
      <Welcome />
      <WhyChooseUs />
      <About />
      <Events />
      <Facilities />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
